import * as React from 'react';
import { FormControl, Grid, Select, MenuItem, TextField } from '@material-ui/core';
import { updateQuestionDataValue } from 'src/effects/utils/preview';
import { ModuleEnum } from 'src/constants/Enum/ModuleEnum';
import { SurveyStatusEnum } from 'src/constants/Enum/SurveyStatusEnum';

export default class DropdownTypeQuestionComponent extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {

        };

        this.onAnswerChange = this.onAnswerChange.bind(this);
        this.onOtherTextChange = this.onOtherTextChange.bind(this);
    }

    setLocalState(props: any) {
        for (let index: number = 1; index <= props.question.class_type; index++) {
            const otherText = props.question.question_responses[index - 1].other_text;

            const questionResponse = props.question.question_responses[index - 1];
            const defaultQuestionResponses = props.question.default_question_responses.find((resp: any) => resp.class_type === index);

            if ((props.isReviewQuetion || !props.isResponsePage) && !questionResponse.value) {
                questionResponse.value = defaultQuestionResponses && defaultQuestionResponses.value;
            }

            if (this.state[props.pageNumber + '_' + props.questionId + "_" + index] !== questionResponse.value ||
                this.state[props.pageNumber + '_' + props.questionId + "_" + index + "_other_text"] !== otherText) {
                this.setState({
                    [props.pageNumber + '_' + props.questionId + "_" + index]: questionResponse.value !== undefined ? questionResponse.value : '',
                    [props.pageNumber + '_' + props.questionId + "_" + index + "_other_text"]: (otherText === undefined || otherText === null) ? null : otherText
                });
            }
        }
    }

    componentDidMount() {
        this.setLocalState(this.props);
    }

    componentWillReceiveProps(nextProps: any) {
        this.setLocalState(nextProps);
    }

    onAnswerChange(classType: any, event: any) {
        this.setState({ [event.target.name]: event.target.value });
        if (!this.props.isReviewQuetion) {
            updateQuestionDataValue(this.props, classType, event.target.value, false, this.state[this.props.pageNumber + '_' + this.props.questionId + "_" + classType + "_other_text"], true, []);
        }
    }

    onOtherTextChange(classType: any, event: any) {
        this.setState({ [event.target.name]: event.target.value });
    }

    onOtherTextBlur(classType: any, event: any) {
        const selectedValueDropdownlist = this.state[this.props.pageNumber + '_' + this.props.questionId + "_" + classType];
        if (!this.props.isReviewQuetion) {
            updateQuestionDataValue(this.props, classType, selectedValueDropdownlist, false, event.target.value, true, []);
        }
    }

    renderQuestion() {
        const elements: any = [];

        if (this.props && this.props.questionId && this.props.question.class_type !== undefined) {
            const isRedBlueApplicable = this.props.question.class_type === 2 && this.props.moduleId === ModuleEnum.VitaminAForecast ? true : false;
            for (let index: number = 1; index <= 3; index++) {
                let formClass = '';
                let labelClass = '';
                if (isRedBlueApplicable) {
                    formClass = index === 1 ? 'blueInput ddlBlueInput' : 'redInput ddlRedInput';
                    labelClass = index === 1 ? 'blueInputLabel ddlLabel' : 'redInputLabel ddlLabel';
                }
                elements.push(<Grid key={this.props.pageNumber + '_label_' + this.props.questionId + "_" + index} item={true} sm={4} >
                    <FormControl margin="normal" fullWidth={true} className={formClass}>
                        <label className={labelClass}>
                            {
                                index === 1 ?
                                    (this.props.question.question_one_title ? this.props.question.question_one_title.en : '') :
                                    index === 2 ?
                                        (this.props.question.question_two_title ? this.props.question.question_two_title.en : '')
                                        :
                                        (this.props.question.question_three_title ? this.props.question.question_three_title.en : '')
                            }
                        </label>
                    </FormControl>
                </Grid>
                )
            }
            for (let index: number = 1; index <= this.props.question.class_type; index++) {
                const selectStateId = this.props.pageNumber + '_' + this.props.questionId + "_" + index;
                const selectedValue = this.state[selectStateId];
                if (this.state[this.props.pageNumber + '_' + this.props.questionId + "_" + index] !== undefined) {
                    let formClass = '';
                    let labelClass = '';
                    let controlClass = '';
                    let menuItemClass = '';
                    if (isRedBlueApplicable) {
                        formClass = index === 1 ? 'blueInput ddlBlueInput' : 'redInput ddlRedInput';
                        labelClass = index === 1 ? 'blueInputLabel ddlLabel' : 'redInputLabel ddlLabel';
                        controlClass = index === 1 ? 'blueInputControl' : 'redInputControl';
                        menuItemClass = index === 1 ? 'blueMenuItemClass' : 'redMenuItemClass';
                    }
                    const defaultQuestionResponses = this.props.question.default_question_responses && this.props.question.default_question_responses.find((resp: any) => resp.class_type === index);
                    const isEditable = this.props.isResponsePage && this.props.surveyType === 1 ? true : defaultQuestionResponses && (defaultQuestionResponses.value || (defaultQuestionResponses.value + '').length > 0) ? defaultQuestionResponses.is_Editable : true;

                    elements.push(<Grid key={this.props.pageNumber + '_' + this.props.questionId + "_" + index} item={true} sm={4} >
                        <FormControl margin="normal" fullWidth={true} className={formClass}>
                            <Select
                                className={controlClass}
                                value={selectedValue}
                                name={selectStateId}
                                displayEmpty={true}
                                onChange={this.onAnswerChange.bind(this, index)}
                                disabled={this.props.surveyStatus === SurveyStatusEnum.Finished || !isEditable}
                                inputProps={{
                                    name: selectStateId,
                                    id: selectStateId
                                }}
                            >
                                <MenuItem value="" key="" className={menuItemClass}>None</MenuItem>
                                {
                                    this.props.question.items[index - 1] &&
                                    this.props.question.items[index - 1].choices.map((item: any, key: any) => {
                                        return <MenuItem
                                            className={menuItemClass}
                                            value={item.value}
                                            key={key}
                                        >{item.text.en}</MenuItem>
                                    })
                                }
                            </Select>
                            {
                                this.props.question.show_other_textbox &&
                                this.state[this.props.pageNumber + '_' + this.props.questionId + "_" + index + "_other_text"] !== undefined &&
                                <>
                                    <label className={labelClass}>Other</label>
                                    <TextField
                                        margin="normal"
                                        variant="outlined"
                                        name={this.props.pageNumber + '_' + this.props.questionId + "_" + index + "_other_text"}
                                        autoFocus={false}
                                        value={this.state[this.props.pageNumber + '_' + this.props.questionId + "_" + index + "_other_text"]}
                                        onChange={this.onOtherTextChange.bind(this, index)}
                                        onBlur={this.onOtherTextBlur.bind(this, index)}
                                        className={controlClass}
                                        disabled={this.props.surveyStatus === SurveyStatusEnum.Finished}
                                    />
                                </>
                            }
                        </FormControl>
                    </Grid>);
                }
            }
        }
        return elements;
    }
    
    render() {
        return (
            <>
                {
                    this.renderQuestion()
                }
            </>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/responses/QuestionTypes/DropdownTypeQuestionComponent.tsx